import { MediaQueries } from '@philips-internal/oswald-ui-constants';
import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { isEnumValid } from '@philips-internal/oswald-ui-utils';
class MediaQueryAPI extends ComponentAPI {
    getQuery() {
        return this.state.query;
    }
    setQuery(query) {
        if (isEnumValid(MediaQueries, query)) {
            this.setState({ query });
        }
    }
}
export default MediaQueryAPI;
//# sourceMappingURL=media-query-api.js.map